const OrderCancellationService = {
  submit(apiWrapper, payload) {
    return apiWrapper
      .apiAxios()
      .post('forms/order-cancellation', payload)
      .then((response) => response.data);
  },
};

export default OrderCancellationService;
